<script setup>
/*
    Manager home page
 */
import {onBeforeMount, onMounted, onUnmounted, reactive, watch} from 'vue'
import {Navbar, Sidebar} from '@/paks/vu-nav'
import {State, fixShadow, go, waitRender} from '@/paks/vu-app'

const page = reactive({
    enable: true,
    nav: {},
})

onBeforeMount(async () => {
    fixShadow()
})

onMounted(() => {
    page.nav = State.config.features.nav || {}
})

onUnmounted(() => {
    fixShadow()
})
</script>

<template>
    <v-app id="manager-app">
        <Navbar />
        <Sidebar v-if="page.nav.sidebar" />
        <v-main :class="State.auth.ready ? 'ready' : 'loading'">
            <vu-tabs />
            <div class="display-area">
                <router-view v-if="page.enable" :key="$route.fullPath"></router-view>
            </div>
        </v-main>
    </v-app>
</template>

<style lang="scss">
:root {
    --v-tabs-height: 48px;
    font-size: var(--v-font-size, '14px');
    font-family: 'Inter', sans-serif;
}
* {
    // All elements
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
html {
    height: 100%;
    width: 100%;
}
body {
    height: 100%;
    padding: 0;
    margin: 0;
}
.v-main {
    background-color: rgb(var(--v-theme-background));
    color: rgb(var(--v-theme-text));
    padding-top: 0 !important;
    min-height: 800px;
    overflow: hidden;
    transition: none !important;
    .display-area {
        height: 100% !important;
        margin: 0;
        .dashboard-home {
            padding: 0 !important;
        }
    }
    .page {
        margin: 20px;
        padding: 28px;
        background-color: rgb(var(--v-theme-surface));
        border: 1px solid rgba(var(--v-theme-primary), 0.4);
        border-radius: 8px;
        @media (max-width: 640px) {
            padding: 8px 22px 22px 22px;
        }
    }
    .action {
        margin-right: 10px !important;
        border: 1px solid rgb(var(--v-theme-border));
        background: none !important;
        box-shadow: none !important;
    }
    .v-btn.v-theme--dark.bg-none {
        border: solid 1px rgba(var(--v-theme-border), 0.5);
    }
}
.v-application, .v-main.loading {
    color: rgb(var(--v-theme-text));
}
.loading {
    position: fixed;
    opacity: 0.5;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    font-family: sans-serif;
    animation: pulse 1s infinite;
}
@keyframes pulse {
    0% {
        opacity: 0.2;
    }
    60% {
        opacity: 0.6;
    }
    100% {
        opacity: 0.2;
    }
}
.slide-out-enter-active,
.slide-out-leave-active {
    transition: transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1) !important;
}
.slide-out-enter,
.slide-out-leave-to {
    transform: translateX(100%);
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease-in !important;
}
.v-icon.closer {
    position: fixed;
    padding: 6px;
    right: 0;
    top: 0;
}
.blackout {
    z-index: 198 !important;
}
.dock.default {
    padding-top: 48px;
    z-index: 199 !important;
}
.v-alert__border {
    border-width: 2px;
}
.v-btn__loader {
    .v-progress-circular {
        height: 13px !important;
        width: 13px !important;
    }
    .v-progress-circular__underlay {
        color: rgb(var(--v-theme-accent));
    }
}
button.v-btn--outlined {
    margin-right: 10px !important;
    border: 1px solid rgb(var(--v-theme-border-lighten-1));
    background: none !important;
    box-shadow: none !important;
}
.tooltip {
    font-size: 1rem;
    background: rgba(10, 10, 10, 0.55);
    color: white;
    opacity: 0.95;
    border: 1px solid rgba(200, 200, 200, 0.5);
    border-radius: 6px;
    margin-top: 8px;
    padding: 8px;
    z-index: 200;
}
//  Vue 3 fix - GraphWidget styles not being emitted
.graph-widget {
    height: 100%;
    .canvas {
        padding: 3cqh 3cqw 5cqh 3cqw;
    }
    .canvas.with-header {
        padding: 11cqh 3cqw 5cqh 3cqw;
    }
}
//  Remove placeholder once input is entered
.v-file-input {
    .v-field-label--floating {
        visibility: hidden !important;
    }
}
/*
input:-webkit-autofill {
    background-color: #111 !important;
    -webkit-box-shadow: 0 0 0px 1000px #111 inset !important;
    -webkit-text-fill-color: #fff !important;
    transition: background-color 5000s ease-in-out 0s;
} */
</style>
